module.exports = __webpack_public_path__ + "static/media/check.48c8e72e.svg";